import React, { useState, useEffect } from 'react';
import './index.less';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import { Icon, Timeline, Tag, Modal, Input, Form } from '@b-design/fusion';
import { formatTime } from '@/utils';
import { getQueryStringArgs } from '@/utils/url-parse';
import { Field } from '@alifd/next';
import NameIcon from '@/components/NameIcon';
import Confirm from '@/components/Confirm';
import Button, { promisifyValidate } from '@/components/Button';
import DefaultAppIcon from '@/components/DefaultAppIcon';

interface Space {
  versionDetail: any;
  initDataSource: any;
  roleList: any;
}
const Space: React.FC<Space> = ({ versionDetail, initDataSource, roleList }) => {
  const field = Field.useField();
  const { init, getValue, setValue, getError } = field;
  const { approveId } = getQueryStringArgs();
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const renderPhone = (v) => {
    let text = '';
    if (v !== '-') {
      if (v?.split('-')[0]) {
        text = `+${v?.split('-')[0]} ${v?.split('-')[1]}`;
      } else {
        text = `${v?.split('-')[1]}`;
      }
    } else {
      text = '';
    }
    return text;
  };

  // 通过按钮
  const handleOk = async () => {
    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'PASSED',
      approveOpinion: 'PASSED',
    });
    if (data) {
      initDataSource();
    }
  };
  // 拒绝按钮
  const handleRejectOk = async () => {
    const [errs, vals] = await promisifyValidate(field);
    if (errs) {
      return;
    }

    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'REJECT',
      approveOpinion: getValue('description'),
    });
    if (data) {
      setIsRejectModalVisible(false);
      initDataSource();
    }
  };

  return (
    <div className="approvals-container">
      <div className="container-left">
        <div className="container-processTitle">
          {$i18n.get({
            id: 'aopf.pages.miniapp.version.info.process.Approvals.Process',
            dm: '审批流程',
          })}
        </div>
        <Timeline>
          <Timeline.Item
            title={
              <div className="progress-item">
                <span>{versionDetail?.createName}</span>
                <span>{formatTime(versionDetail?.gmtCreate)}</span>
              </div>
            }
            content={
              <div className="progress-content">
                <div className="progress-dec">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.process.Submit.Space.Onboarding',
                    dm: '提交空间入驻申请',
                  })}
                </div>
                <Tag data-square>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.process.Application',
                    dm: '申请',
                  })}
                </Tag>
                <span className="progress-content-text">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.process.Additional.Information.Space',
                    dm: '申请发布新版本',
                  })}
                </span>
              </div>
            }
          />
          {versionDetail?.status !== 'PROCESSING' ? (
            <Timeline.Item
              title={
                <div className="progress-item">
                  <span>{versionDetail?.modifiedName}</span>
                  <span>{formatTime(versionDetail?.gmtModified)}</span>
                </div>
              }
              content={
                <div className="progress-content">
                  {versionDetail?.approveAction === 'PASSED' ? (
                    <div>
                      <div className="progress-dec">
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.version.info.process.Review.Space',
                          dm: '审查申请',
                        })}
                      </div>
                      <Tag data-square data-tag-color="cold-green">
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.version.info.process.Passed',
                          dm: '通过',
                        })}
                      </Tag>
                    </div>
                  ) : versionDetail?.approveAction === 'WITHDRAW' ? (
                    <>
                      <div className="progress-dec">
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.version.info.process.Review.WithDraw',
                          dm: '撤回发布',
                        })}
                      </div>
                      <Tag data-square color="#FFF4ED" style={{ color: '#FF7E33' }}>
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.version.info.process.Withdraw',
                          dm: '回退',
                        })}
                      </Tag>
                      {/* <span className="progress-content-text">{versionDetail?.approveOpinion}</span> */}
                    </>
                  ) : (
                    <>
                      <div className="progress-dec">
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.version.info.process.Review.Space',
                          dm: '审查申请',
                        })}
                      </div>
                      <Tag data-square data-tag-color="red">
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.version.info.process.Refused',
                          dm: '拒绝',
                        })}
                      </Tag>
                      <span className="progress-content-text">
                        {versionDetail?.approveOpinion
                          ? versionDetail?.approveOpinion
                          : $i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.No.Reason',
                            dm: '拒绝',
                          })}
                      </span>
                    </>
                  )}
                </div>
              }
            />
          ) : (
            <></>
          )}
        </Timeline>
        {versionDetail?.status === 'PROCESSING' && roleList?.includes('ADMIN') && (
          <div className="progress-withdraw">
            <Confirm
              trigger={
                <Button type="primary" style={{ marginRight: '16px' }}>
                  {$i18n.get({
                    id: 'aopf.approvals.datail.approve',
                    dm: '批准',
                  })}
                </Button>
              }
              dialogTitle={$i18n.get({
                id: 'aopf.pages.approvals.version.info.process.approved',
                dm: '审批详情',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.approvals.detail.agreeContent.space',
                dm: '你正在处理三方入驻申请,是否批准',
              })}
              onClick={handleOk}
            />
            <Button type="secondary" onClick={() => setIsRejectModalVisible(true)}>
              {$i18n.get({
                id: 'aopf.approvals.datail.reject',
                dm: '拒绝',
              })}
            </Button>
          </div>
        )
        }
      </div >

      <div className="container-right">
        {versionDetail?.extInfo?.space?.iconPublicUrl ? (
          <img className="logo" src={versionDetail?.extInfo?.space?.iconPublicUrl} />
        ) : (
          // <div className="logo-seat" />
          <NameIcon
            name={versionDetail?.extInfo?.space?.name}
            shape="square"
            styles={{ height: 64, width: 64, fontSize: 28 }}
          />
        )}
        <div className="right-appInfo">
          {$i18n.get({
            id: 'aopf.pages.approvals.space.information',
            dm: '空间信息',
          })}
        </div>
        <div className="right-content">
          <div className="right-icon">
            <Icon type="mobile--outline" size="xs" />
          </div>
          <div className="right-title">
            {$i18n.get({
              id: 'aopf.pages.approvals.space.name',
              dm: '空间名称',
            })}
          </div>
          <div className="left-context">{versionDetail?.extInfo?.space?.name}</div>
        </div>

        <div className="right-content">
          <div className="right-icon">
            <Icon type="apps--outline" size="xs" />
          </div>
          <div className="right-title">
            {$i18n.get({
              id: 'aopf.pages.approvals.space.companyName',
              dm: '公司名称',
            })}
          </div>
          <div className="left-context">{versionDetail?.extInfo?.company?.name}</div>
        </div>

        <div className="right-content">
          <div className="right-icon">
            <Icon type="apps--outline" size="xs" />
          </div>
          <div className="right-title">
            {$i18n.get({
              id: 'aopf.pages.approvals.space.BusinessAddress',
              dm: '公司地址',
            })}
          </div>
          <div className="left-context">{versionDetail?.extInfo?.company?.address}</div>
        </div>

        <div className="right-content">
          <div className="right-icon">
            <Icon type="user--outline" size="xs" />
          </div>
          <div className="right-title">
            {$i18n.get({
              id: 'aopf.pages.approvals.space.BusinessRepresentative',
              dm: '公司法人',
            })}
          </div>
          <div className="left-context">{versionDetail?.extInfo?.company?.principal}</div>
        </div>

        <div className="right-content">
          <div className="right-icon">
            <Icon type="wikis--outline" size="xs" />
          </div>
          <div className="right-title">
            {$i18n.get({
              id: 'aopf.pages.approvals.space.Website',
              dm: '网址',
            })}
          </div>
          <div className="left-context">{versionDetail?.extInfo?.company?.webPage}</div>
        </div>

        <div className="right-content">
          <div className="right-icon">
            <Icon type="user--outline" size="xs" />
          </div>
          <div className="right-title">
            {$i18n.get({
              id: 'aopf.pages.approvals.space.ContactNumber',
              dm: '联系方式',
            })}
          </div>
          <div className="left-context">
            {renderPhone(versionDetail?.extInfo?.company?.customerPhone)}
          </div>
        </div>

        <div className="right-content">
          <div className="right-icon">
            <Icon type="user--outline" size="xs" />
          </div>
          <div className="right-title">
            {$i18n.get({
              id: 'aopf.pages.approvals.space.EmailAddress',
              dm: '邮箱',
            })}
          </div>
          <div className="left-context">{versionDetail?.extInfo?.company?.customerEmail}</div>
        </div>
      </div>
      <Modal
        title={$i18n.get({
          id: 'aopf.pages.approvals.version.info.process.reject',
          dm: '拒绝申请',
        })}
        // data-size="xs"
        visible={isRejectModalVisible}
        // onOk={handleRejectOk}
        onCancel={() => setIsRejectModalVisible(false)}
        closeMode={['close', 'esc', 'mask']}
        onClose={() => setIsRejectModalVisible(false)}
        footer={
          <div>
            <Button onClick={() => setIsRejectModalVisible(false)}>
              {$i18n.get({
                id: 'aopf.pages.approvals.version.info.confirm.Cancel',
                dm: '取消',
              })}
            </Button>
            <Button type="primary" onClick={handleRejectOk} style={{ marginLeft: '8px' }}>
              {$i18n.get({
                id: 'aopf.pages.approvals.version.info.confirm.Ok',
                dm: '确定',
              })}
            </Button>
          </div>
        }
      >
        <div
          style={{
            marginTop: '20px',
            width: '500px',
            fontSize: '14px',
            letterSpacing: '0.47px',
            lineHeight: '20px',
            fontWeight: '400',
          }}
        >
          <Form>
            <Form.Item
              name="description"
              label={$i18n.get({ id: 'aopf.pages.approvals.form.title.description', dm: '描述' })}
            >
              <Input.TextArea
                placeholder={$i18n.get({
                  id: 'aopf.pages.approvals.form.Description.placeholder',
                  dm: '输入2-200个字符的描述',
                })}
                autoHeight={{ minRows: 4, maxRows: 8 }}
                style={{ width: '470px' }}
                {...init('description', {
                  initValue: '',
                  rules: {
                    required: true,
                    minLength: 2,
                    maxLength: 200,
                    message: $i18n.get({
                      id: 'aopf.pages.approvals.form.Description.placeholder',
                      dm: '输入2-200个字符的描述',
                    }),
                  },
                })}
                showLimitHint
                maxLength={200}
              />
              <p style={{ fontSize: 12, color: '#c82727' }}>{getError('description')}</p>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div >
  );
};
export default Space;
